import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
} from "react-admin";
import OrgSelector from "../../components/OrgSelector";
import cameraTypes from "../../defaults/CameraTypes";
import UploadButton from "../../components/camera/CameraMapButton";

const CameraEdit = (props) => {

  return (
    <Edit {...props} title="Edit Camera">
      <SimpleForm {...props}>
        <OrgSelector required/>
        <TextInput fullWidth label="Name" source="name" validate={[required()]} />
        <TextInput fullWidth label="Description" source="description" />
        <TextInput fullWidth label="Camera ID" source="camera_id" validate={[required()]} />
        <SelectInput fullWidth label="Camera Type" source="camera_type" validate={[required()]} choices={cameraTypes} />
        <UploadButton type="camera" fileName="map" {...props} />
      </SimpleForm>
    </Edit>
  );
};

export default CameraEdit;
